import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmosphere%20with%20warm%20amber%20and%20crimson%20lighting%2C%20abstract%20digital%20news%20and%20gossip%20concept%2C%20floating%20newspaper%20fragments%20and%20social%20media%20icons%20dissolving%20into%20darkness%2C%20dramatic%20contrast%20between%20light%20and%20shadow%2C%20cinematic%20noir%20aesthetic%2C%20editorial%20photography%20style%2C%20sense%20of%20hidden%20truths%20and%20secrets%20being%20revealed%2C%20modern%20Chinese%20urban%20night%20vibe%2C%20warm%20golden%20accents%20against%20deep%20dark%20background&width=1800&height=1000&seq=hero-bg-51anwang&orientation=landscape"
        alt="51暗网 - 每日吃瓜黑料实时追踪"
        title="51暗网 - 每日吃瓜黑料实时追踪"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-300 text-xs font-medium mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
            实时更新中 · 今日已更新12条爆料
          </div>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6">
            每日吃瓜黑料
            <br />
            <span className="text-accent-400">实时追踪更新</span>
          </h1>
          <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-xl mb-8">
            51暗网提供最新网红塌房、明星黑料、八卦爆料追踪。覆盖娱乐圈内幕、直播翻车、吃瓜大瓜等热门内容，
            每日更新，不错过任何一个重磅爆料。
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <Link
              to="/category/chigua-dagua"
              className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 rounded-lg bg-white/10 text-white font-medium text-sm hover:bg-white/20 backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer border border-white/20"
            >
              下载51暗网App
            </Link>
          </div>

          <div className="flex items-center gap-6 mt-10 text-white/60 text-xs">
            <div className="flex items-center gap-2">
              <span className="text-white font-bold text-lg">128万+</span>
              <span>日活用户</span>
            </div>
            <div className="w-px h-5 bg-white/20"></div>
            <div className="flex items-center gap-2">
              <span className="text-white font-bold text-lg">5.6万+</span>
              <span>累计爆料</span>
            </div>
            <div className="w-px h-5 bg-white/20"></div>
            <div className="flex items-center gap-2">
              <span className="text-white font-bold text-lg">99.7%</span>
              <span>真实率</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}